// let devBaseUrl = 'https://ajnxapi.wanjuan.cn/api'
let devBaseUrl = 'https://childapi.wanjuan.cn/api'
let devBaseTitle = "爱国主义主题数字阅读体验空间";
export default {
  devBaseUrl,
  devBaseTitle,
  topMenu:false,
  slideMenu:true,
  clock:false,//打卡
  tabbar:false,
  navigator:false,
  hudong:false,
  showMusic:true,
  site:[
  {
    "spot":2,
    "name":'长沙橘子洲景区',
    "pic":"full-img2.png",
    // "center":[112.962391,28.195644],
    "center":[112.962391,28.170644],
    "mulPic":true,
    "mapPic":'map/333',
    // "imgCenter":[[112.959039, 28.207976],[112.966619, 28.164682]],
    "imgCenter":[
      [[112.959039,28.207976],[112.966619,28.2036466]],
      [[112.959039,28.2036466],[112.966619,28.1993172]],
      [[112.959039,28.1993172],[112.966619,28.1949878]],
      [[112.959039,28.1949878],[112.966619,28.1906584]],
      [[112.959039,28.1906584],[112.966619,28.186329]],
      [[112.959039,28.186329],[112.966619,28.1819996]],
      [[112.959039,28.1819996],[112.966619,28.1776702]],
      [[112.959039,28.1776702],[112.966619,28.1733408]],
      [[112.959039,28.1733408],[112.966619,28.1690114]],
      [[112.959039,28.1690114],[112.966619,28.164682]],
    ],
    "initZoom":15.5,
    "zooms":[14,18],
    "dotDisableZoom":8,
    "bounds":[[112.10, 28.153],[112.98, 28.22]],
  },
  {
    "spot":1,
    "name":"安江农校纪念园",
    "pic":"full-img1.png",
    "center":[110.150555, 27.345845],
    "mapPic":"mapnew_small.png",
    "imgCenter":[[110.14868070099638, 27.341524786075484],[110.15308090546965, 27.349780812305705]],
    "initZoom":17,
    "zooms":[16,19],
    "dotDisableZoom":10,
    "bounds":[[110.14, 27.335],[110.16, 27.353]],//设置地图移动范围 【西南角】，【东北角】
  },
  {
    "spot":3,
    "name":'更多湖南各地的爱国主义教育基地',
    "pic":"full-img3.png",
    "path":'/moreScience',
    "full":true
  }]
};